import { createFileRoute } from '@tanstack/react-router'
import { UserActionsList } from '@/components/user-actions-list'

export const Route = createFileRoute('/_authenticated/user-actions')({
  component: UserActions,
})

function UserActions() {
  return (
    <div className='p-4'>
      <h1 className="text-2xl font-bold mb-4">Kullanıcı Hareketleri</h1>
      <p className="text-gray-600 mb-6">Bu sayfada kullanıcı hareketlerini görüntüleyebilirsiniz.</p>
      <UserActionsList />
    </div>
  )
}